import React from 'react'
import { SearchPQRs } from '@auteco/pages/ReportsPages/SearchPQRs'

const SearchPQRsContainer = () => (
    <SearchPQRs />
)

export default SearchPQRsContainer